export const contentData = {
  spanish:{
    nodata:'Sin Registro',
    notable:'No existen registros de outsourcing',
    tableTitle:'',
    header:['ID','Nombre','Responsable','Especificaciones','Periodicidad','Salario Neto',],
    modals:{
      warning_delete_item:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      },
      cerl:{
        name:'Certificado eFirma',
        button:'Guardar',
        cancelButton:'Cancelar'
      }
    },
  },
  english:{

  }
}